import React from "react";
import { withTranslation } from "react-i18next";
import CurrencyInput from "Shared/CurrencyInput";
import { CreditRatingFormInputProps } from "./CRF.types";
import { CRFClassNameGenerator as c, resetCustomErrorMessage, setCustomErrorMessage } from "./CRF.utils";

const IncomeYearInputs = ({
    income,
    handleIncomeUpdate,
    onChange,
    t,
    year,
}: CreditRatingFormInputProps & { income: number; handleIncomeUpdate: (value: number) => void; year: string }) => {
    return (
        <div className={c("section")}>
            <div className={c(["subgroup", "halves"])}>
                <label htmlFor={c(["input", "income"])} className={c("label")}>
                    {t("SoftCreditPull.income")}
                </label>
                <CurrencyInput
                    className={c(["input"])}
                    customWrapperClass={c(["income", "incomeWrapper"])}
                    updateValue={handleIncomeUpdate}
                    value={income}
                />
            </div>
            <div className={c(["subgroup", "halves"])}>
                <label htmlFor={c(["input", "year"])} className={c("label")}>
                    {t("SoftCreditPull.year")}
                </label>
                <input
                    id={c(["input", "year"])}
                    className={c(["input", "year"])}
                    placeholder="YYYY"
                    type="number"
                    name="year"
                    required
                    onChange={onChange("year")}
                    value={year}
                    min={1900}
                    max={new Date().getFullYear()}
                    onInput={resetCustomErrorMessage}
                    onInvalid={setCustomErrorMessage(t("SoftCreditPull.validation.year"))}
                />
            </div>
        </div>
    );
};

export default withTranslation()(IncomeYearInputs);
